// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"3f2e7282","363":"0663f439","595":"f4200051"}[chunkId] + ".chunk.css";
};